import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiAnalyticsPlansDocumentFileCategoriesIndexResponseType,
  ApiAnalyticsPlansDocumentFileCategoriesIndexRequestType,
} from "~/domains";

type RequestDataType = {
  params?: ApiAnalyticsPlansDocumentFileCategoriesIndexRequestType;
};

const request = async ({
  params,
}: RequestDataType): Promise<ApiAnalyticsPlansDocumentFileCategoriesIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiAnalyticsPlansDocumentFileCategoriesIndexResponseType>(
      "/api/analytics_plans/document_file_categories",
      params,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ApiAnalyticsPlansDocumentFileCategoriesIndexRequestType;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisAnalyticsPlansDocumentFileCategoriesIndex = ({
  params,
  config = {},
}: PropsType = {}): UseQueryResult<ApiAnalyticsPlansDocumentFileCategoriesIndexResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisAnalyticsPlansDocumentFileCategoriesIndex", params],
    queryFn: () => request({ params }),
  });
};
